import { defineStore } from 'pinia'
import type { ISlug } from '@/types/Global'

export const usePageStore = defineStore('pageStore', () => {
  const slugs = ref<ISlug[]>()

  function setSlugs(value: [ISlug], defaultValue: [ISlug]) {
    const valueLangSet = new Set(value.map((item) => item.lang))

    if (!defaultValue.some((item) => valueLangSet.has(item.lang))) {
      value.unshift(...defaultValue)
    }
    slugs.value = value
  }

  return {
    slugs,
    setSlugs
  }
})
